import ignore from 'ignore'

import { bridge } from './index'

interface FileEntry {
  name: string
  relativePath?: string
  isDirectory: boolean
}

const DEFAULT_EXCLUDE_DIRS = ['.git', 'node_modules', 'target', '.idea', '.vscode', '.DS_Store']

const DEFAULT_EXCLUDE_PATTERNS = [
  '.git',
  'node_modules',
  '.DS_Store',
  'target',
  '.idea',
  '.vscode',
  '*.class',
  '*.jar'
]

export async function collectArchiveFiles(
  sourcePath: string,
  options?: { excludePatterns?: string[] }
): Promise<string[]> {
  const ig = ignore()

  const gitignoreResult = await bridge.call<{ content: string }>('fs', 'read', {
    path: `${sourcePath}/.gitignore`
  })
  if (gitignoreResult.success && gitignoreResult.data?.content) {
    ig.add(gitignoreResult.data.content)
  }

  ig.add(DEFAULT_EXCLUDE_PATTERNS)
  if (options?.excludePatterns?.length) {
    ig.add(options.excludePatterns)
  }

  const listResult = await bridge.call<{ entries: FileEntry[] }>('fs', 'list', {
    path: sourcePath,
    recursive: true,
    excludeDirs: DEFAULT_EXCLUDE_DIRS
  })

  if (!listResult.success || !listResult.data?.entries) {
    throw new Error(listResult.error ?? 'Failed to list directory')
  }

  return listResult.data.entries
    .filter(e => !e.isDirectory && e.relativePath && !ig.ignores(e.relativePath))
    .map(e => e.relativePath!)
}
